import { useRef } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogAd } from '@/redux/modules/catalog/ad/catalogAd.selectors';
import { CatalogAds } from '@/redux/modules/catalog/ad/catalogAd.types';
import { getCatalogSellerId } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { AmpProduct, useTrackAmpAvailable } from '@/utils/amplitude/analytics';
import { useSearchResultsAdExperiment } from '@/utils/amplitude/experiments/hooks/useSearchResultsAdExperiment';

import { SearchResultsAd } from './SearchResultsAd';
import { SearchResultsAdExperiment } from './SearchResultsAdExperiment';

type Props = {
    page: number;
    searchTerm: string;
};

export const SearchResultsAdContainer = ({ page, searchTerm }: Props) => {
    const lastTrackedRef = useRef<string | null>(null);
    const showNewAdDesign = useSearchResultsAdExperiment();

    const trackAmpAvailable = useTrackAmpAvailable();

    const { adUnitId, catalogId } = useAppSelector((state) =>
        getCatalogAd(state, { pageName: CatalogAds.SearchPageBanner })
    );
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));

    if (!catalogId || !adUnitId) {
        return null;
    }

    const trackingKey = `${page}:${searchTerm}`;
    if (lastTrackedRef.current !== trackingKey) {
        trackAmpAvailable({ ampProduct: AmpProduct.SearchPageBanner, catalogId, houseId: sellerId });
        lastTrackedRef.current = trackingKey;
    }

    return showNewAdDesign ? <SearchResultsAdExperiment /> : <SearchResultsAd />;
};
